export enum InvoiceDetailsErrorsEnum {
  ShipmentNotFound = 'DSPN010-002E',
  RelatedClaimNotFound = 'DSPN020-087E',
  MultipleRelatedClaims = 'DSPN020-089E',
  RelatedClaimNotApproved = 'DSPN020-088E',
  RelatedClaimWithPendingRebuttal = 'DSPN020-090E',
}
